export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s(를) 선택하지 않음';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s을 비워둘 수 없음';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s는 필수 항목임';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s을(를) 올바르게 기재하지 않음';
                break;

            case 'opt-in':
                translation = '계속하려면 박스를 체크하십시오';
                break;

            default:
                translation = '이 항목을 올바르게 기재하지 않음';
                break;
        }

        return translation;
    }
}
